import { gql } from '@apollo/client';

export const VERIFY_CODE = gql`
  mutation verifyCode($email: String!, $code: String!, $createdAt: String!) {
    verifyCode(email: $email, code: $code, createdAt: $createdAt) {
      token
      verified
    }
  }
`;
